// PGCET MCA Mock 7 — Mathematics (questions 1–30)
const pgcetmcaMathematics = [
  {
    id: 1,
    question: "If A = {1, 2, 3, 4} and B = {3, 4, 5, 6}, then the symmetric difference A Δ B is",
    options: ["A. {3, 4}", "B. {1, 2, 5, 6}", "C. {1, 2, 3, 4, 5, 6}", "D. {1, 2}"],
    answer: "B"
  },
  {
    id: 2,
    question: "The number of subsets of a set with 6 elements that contain at least 2 elements is",
    options: ["A. 57", "B. 58", "C. 63", "D. 64"],
    answer: "A"
  },
  {
    id: 3,
    question: "The relation R = {(1, 1), (2, 2), (3, 3), (1, 2), (2, 1)} on the set {1, 2, 3} is",
    options: ["A. reflexive but not symmetric", "B. symmetric but not transitive", "C. an equivalence relation", "D. transitive but not reflexive"],
    answer: "C"
  },
  {
    id: 4,
    question: "The number of reflexive relations that can be defined on a set with 4 elements is",
    options: ["A. 2¹⁶", "B. 2⁸", "C. 2⁴", "D. 2¹²"],
    answer: "D"
  },
  {
    id: 5,
    question: "The domain of the function f(x) = √(x − 2) + 1/log₁₀(5 − x) is",
    options: ["A. [2, 5)", "B. [2, 5) − {4}", "C. (2, 5)", "D. [2, 4)"],
    answer: "B"
  },
  {
    id: 6,
    question: "If f(x) = 2x + 3 and g(x) = x², then (f∘g)(2) − (g∘f)(2) equals",
    options: ["A. −38", "B. 38", "C. −28", "D. 0"],
    answer: "A"
  },
  {
    id: 7,
    question: "If f(x) = (2x + 1)/(x − 3), x ≠ 3, then f⁻¹(x) is",
    options: ["A. (x − 3)/(2x + 1)", "B. (3x − 1)/(x + 2)", "C. (3x + 1)/(x − 2)", "D. (x + 3)/(2x − 1)"],
    answer: "C"
  },
  {
    id: 8,
    question: "A student has to answer 4 questions out of 10, of which 2 particular questions are compulsory. The number of ways of choosing the questions is",
    options: ["A. 56", "B. 45", "C. 70", "D. 28"],
    answer: "D"
  },
  {
    id: 9,
    question: "The number of diagonals of a decagon (10-sided polygon) is",
    options: ["A. 45", "B. 35", "C. 40", "D. 30"],
    answer: "B"
  },
  {
    id: 10,
    question: "If ⁿC₈ = ⁿC₁₂, then ⁿC₁₈ equals",
    options: ["A. 190", "B. 380", "C. 20", "D. 210"],
    answer: "A"
  },
  {
    id: 11,
    question: "In how many ways can 5 boys and 4 girls be arranged in a row so that no two girls sit together?",
    options: ["A. 2880", "B. 43200", "C. 14400", "D. 86400"],
    answer: "B"
  },
  {
    id: 12,
    question: "The number of triangles that can be formed from 12 points in a plane, of which exactly 5 are collinear, is",
    options: ["A. 220", "B. 200", "C. 210", "D. 205"],
    answer: "C"
  },
  {
    id: 13,
    question: "If sin θ + cos θ = √2, then tan θ + cot θ equals",
    options: ["A. 1", "B. √2", "C. 1/2", "D. 2"],
    answer: "D"
  },
  {
    id: 14,
    question: "The value of (1 − tan²15°)/(1 + tan²15°) is",
    options: ["A. 1/2", "B. √3/2", "C. √3", "D. 1/√3"],
    answer: "B"
  },
  {
    id: 15,
    question: "The maximum value of 3 sin x + 4 cos x + 5 is",
    options: ["A. 10", "B. 12", "C. 7", "D. 9"],
    answer: "A"
  },
  {
    id: 16,
    question: "The fundamental period of the function f(x) = sin 3x + cos 2x is",
    options: ["A. π", "B. 2π/3", "C. 2π", "D. 6π"],
    answer: "C"
  },
  {
    id: 17,
    question: "If cos A = 3/5 and cos B = 5/13, where A and B are acute angles, then cos(A + B) equals",
    options: ["A. 63/65", "B. −33/65", "C. 33/65", "D. −63/65"],
    answer: "B"
  },
  {
    id: 18,
    question: "The value of lim (x → 2) of (x³ − 8)/(x² − 4) is",
    options: ["A. 3", "B. 2", "C. 4", "D. 12"],
    answer: "A"
  },
  {
    id: 19,
    question: "The value of lim (x → ∞) of (1 + 3/x)ˣ is",
    options: ["A. e", "B. 3e", "C. e^(1/3)", "D. e³"],
    answer: "D"
  },
  {
    id: 20,
    question: "The value of lim (x → 0) of (2ˣ − 1)/x is",
    options: ["A. 2", "B. logₑ 2", "C. 1/2", "D. 0"],
    answer: "B"
  },
  {
    id: 21,
    question: "The derivative of logₑ(sec x + tan x) with respect to x is",
    options: ["A. sec x tan x", "B. tan x", "C. sec x", "D. sec² x"],
    answer: "C"
  },
  {
    id: 22,
    question: "If y = e²ˣ sin x, then the value of dy/dx at x = 0 is",
    options: ["A. 0", "B. 2", "C. 3", "D. 1"],
    answer: "D"
  },
  {
    id: 23,
    question: "The function f(x) = x³ − 6x² + 9x + 1 has a local maximum at",
    options: ["A. x = 1", "B. x = 3", "C. x = 2", "D. x = 0"],
    answer: "A"
  },
  {
    id: 24,
    question: "The slope of the tangent to the curve y = x² − 3x + 2 at the point where it cuts the y-axis is",
    options: ["A. 3", "B. 2", "C. −3", "D. −2"],
    answer: "C"
  },
  {
    id: 25,
    question: "The median of the observations 12, 7, 3, 15, 9, 10, 4, 18 is",
    options: ["A. 9", "B. 9.5", "C. 10", "D. 10.5"],
    answer: "B"
  },
  {
    id: 26,
    question: "The mean deviation about the mean of the observations 2, 4, 6, 8, 10 is",
    options: ["A. 2.4", "B. 2", "C. 3", "D. 2.8"],
    answer: "A"
  },
  {
    id: 27,
    question: "If the mean of a distribution is 40 and its standard deviation is 10, then the coefficient of variation is",
    options: ["A. 4%", "B. 40%", "C. 25%", "D. 2.5%"],
    answer: "C"
  },
  {
    id: 28,
    question: "The mode of the data 3, 5, 7, 5, 8, 9, 5, 7, 3, 7, 7 is",
    options: ["A. 5", "B. 3", "C. 8", "D. 7"],
    answer: "D"
  },
  {
    id: 29,
    question: "The Boolean expression (A + B)(A + C) simplifies to",
    options: ["A. AB + C", "B. AC + B", "C. ABC", "D. A + BC"],
    answer: "D"
  },
  {
    id: 30,
    question: "The complement of the Boolean expression AB′ + A′B is",
    options: ["A. AB + A′B′", "B. A′B + AB′", "C. A + B", "D. A′B′"],
    answer: "A"
  }
];

export default pgcetmcaMathematics;
